(ns practitest.frontend.routing.backend-routes
  (:require [re-frame.core :as re-frame]
            [reitit.core :as r]
            [reagent.core :as reagent]
            [reitit.frontend :as rf]
            [practitest.frontend.subs :as subs]
            [practitest.frontend.milestone.readiness-index.events :as-alias ri.events]
            [practitest.frontend.milestone.events :as-alias m.events]
            [practitest.frontend.common.utils :as utils]))

;; Initial version generated with `rake clojure:routes`
(def backend-routes
  [["/accounts/:account_id/settings"
    {:name "account/accounts#settings"
     ;; Rails helper: account_settings
     :method :get}]
   ["/accounts/:account_id/subscriptions"
    {:name "account/accounts#subscriptions"
     ;; Rails helper: account_subscriptions
     :method :get}]
   ["/accounts/:account_id/projects"
    {:name "account/accounts#projects"
     ;; Rails helper: account_projects
     :method :get}]
   ["/accounts/:account_id/manage_users"
    {:name "account/accounts#manage_users"
     ;; Rails helper: manage_users_account
     :method :get}]
   ["/accounts/:account_id/dashboard_settings"
    {:name "account/accounts#dashboard_settings"
     ;; Rails helper: dashboard_settings_account
     :method :get}]
   ["/accounts/:account_id/usage_and_limits"
    {:name "account/accounts#usage_and_limits"
     ;; Rails helper: usage_and_limits_account
     :method :get}]
   ["/accounts/:account_id/llm_budget_data"
    {:name "account/accounts#llm_budget_data"
     ;; Rails helper: llm_budget_data_account
     :method :get}]
   ["/:account_id/landing/projects"
    {:name "landing#projects"
     ;; Rails helper: landing_projects
     :method :get}]
   ["/:account_id/landing/assigned_items"
    {:name "landing#assigned_items"
     ;; Rails helper: landing_assigned_items
     :method :get}]
   ["/:account_id/landing/histories"
    {:name "landing#histories"
     ;; Rails helper: landing_histories
     :method :get}]
   ["/accounts/:account_id/integrations"
    {:name "account/accounts#integrations"
     ;; Rails helper: integrations_account
     :method :get}]
   ["/accounts/:account_id/xbot"
    {:name "account/accounts#xbot"
     ;; Rails helper: xbot
     :method :get}]
   ["/accounts/:account_id/global_fields"
    {:name "account/accounts#global_fields"
     ;; Rails helper: global_fields
     :method :get}]
   ["/accounts/:account_id/global_fields/new"
    {:name "accounts#global_fields_new"
     ;; Rails helper: global_fields/new
     :method :get}]
   ["/accounts/:account_id/global_fields/edit/:global-field-id"
    {:name "accounts#global_fields_edit"
     ;; Rails helper: global_fields/edit
     :method :get}]
   ["/accounts/:account_id/global_fields"
    {:name "accounts#global_fields_create"
     ;; Rails helper: global_fields/new
     :method :post}]
   ["/accounts/:account_id/global_fields/:global-field-id"
    {:name "accounts#global_fields_update"
     ;; Rails helper: global_fields/update
     :method :put}]
   ["/accounts/:account_id/global_fields/:global_field_id/convert"
    {:name "global_fields#convert"
     :method :post}]
   ["/accounts/:account_id/global_fields/:global_field_id/check_value_usage"
    {:name "global_fields#check_value_usage"
     :method :post}]
   ["/accounts/:account_id/global_fields/:global_field_id/delete_list_value"
    {:name "global_fields#delete_list_value"
     :method :post}]
   ["/accounts/:account_id/global_fields/:global_field_id/rename_value_count"
    {:name "global_fields#rename_value_count"
     :method :post}]
   ["/accounts/:account_id/global_fields/:global_field_id/rename_list_value"
    {:name "global_fields#rename_list_value"
     :method :post}]
   ["/accounts/:account_id/global_fields/migrate"
    {:name "global_fields#migrate"
     :method :post}]
   ["/accounts/:account_id/global_fields/project_fields_for_migration"
    {:name "global_fields#project_fields_for_migration"
     :method :get}]
   ["/accounts/:account_id/global_fields/migration_entity_count"
    {:name "global_fields#migration_entity_count"
     :method :post}]
   ["/accounts/:account_id/global_fields/check_migration_lock"
    {:name "global_fields#check_migration_lock"
     :method :get}]
   ["/accounts/:account_id/global_fields/:global_field_id/linked_lists"
    {:name "global_fields#linked_lists"
     :method :get}]
   ["/accounts/:account_id/global_fields/:global_field_id/linked_project_names"
    {:name "global_fields#linked_project_names"
     :method :get}]
   ["/accounts/:account_id/global_fields/:global_field_id/import_linked_lists"
    {:name "global_fields#import_linked_lists"
     :method :post}]
   ["/accounts/:account_id/global_fields/validate_linkage"
    {:name "global_fields#validate_linkage"
     :method :post}]
   ["/accounts/:account_id/active_sessions_data"
    {:name "account/accounts#active_sessions_data"
     ;; Rails helper: active_sessions_data_account
     :method :get}]
   ["/accounts/:account_id/terminate_user_session"
    {:name "account/accounts#terminate_user_session"
     ;; Rails helper: kick_user_account
     :method :post}]
   ["/accounts/:account_id/user_activity_log_data"
    {:name "account/accounts#user_activity_log_data"
     ;; Rails helper: user_activity_log_data_account
     :method :get}]
   ["/users/:id/user_projects"
    {:name "users#user_projects"
     ;; Rails helper: user_projects_user
     :method :get}]
   ["/users/:id/pin_user_project"
    {:name "users#pin_user_project"
     ;; Rails helper: pin_user_project_user
     :method :post}]
   ["/lms_webhooks/sign_lms"
    {:name "lms_webhooks#sign_lms"
     ;; Rails helper: sign_lms
     :method :post}]
   ["/users/:id/user_accounts"
    {:name "users#user_accounts"
     ;; Rails helper: user_accounts_user
     :method :get}]
   ["/sessions"
    {:name "sessions#create"
     ;; Rails helper: sessions
     :method :post}]
   ["/sessions/check_sso"
    {:name "sessions#check_sso"
     ;; Rails helper: check_sso_sessions
     :method :get}]
   ["/login_mfa"
    {:name "sessions#login_mfa"
     ;; Rails helper: login_mfa
     :method :post}]
   ["/forgot_password"
    {:name "sessions#forgot_password"
     ;; Rails helper: forgot_password
     :method :post}]
   ["/reset_password/:code"
    {:name "sessions#reset_password"
     ;; Rails helper: reset_password
     :method :post}]
   ["/signups"
    {:name "signups#create"
     ;; Rails helper: signups
     :method :post}]
   ["/signups/:id"
    {:name "signups#update"
     ;; Rails helper: signup
     :method :put}]
   ["/logout"
    {:name "sessions#destroy"
     ;; Rails helper: logout
     :method :get}]
   ["/change_project"
    {:name "sessions#change_project"
     ;; Rails helper: change_project
     :method :get}]
   ["/change_account_to_landing"
    {:name "sessions#change_account_to_landing"
     ;; Rails helper: change_account_to_landing
     :method :get}]
   ["/:account_id/landing/account_info"
    {:name "landing#account_info"
     ;; Rails helper: landing_account_info
     :method :get}]
   ["/:account_id/landing/account_message"
    {:name "landing#account_message"
     ;; Rails helper: landing_account_message
     :method :get}]
   ["/sessions/access_token"
    {:name "sessions#access_token"
     ;; Rails helper: access_token_sessions
     :method :get}]
   ["/sessions/check_license_availability"
    {:name "sessions#check_license_availability"
     ;; Rails helper: check_license_availability_sessions
     :method :get}]
   ["/sessions/online"
    {:name "sessions#online"
     ;; Rails helper: online_sessions
     :method :post}]
   ["/tutorials"
    {:name "tutorials#index"
     ;; Rails helper: tutorials
     :method :get}]
   ["/projects/:project_id/search"
    {:name "search#index"
     ;; Rails helper: project_search
     :method :get}]
   ["/projects/:project_id/search/find_similar"
    {:name "search#find_similar"
     ;; Rails helper: project_search
     :method :get}]
   ["/projects/:id/user_toggle_feature/:user_id/:feature"
    {:name "projects#user_toggle_feature"
     ;; Rails helper: user_toggle_feature_project
     :method :post}]
   ["/projects/:project_id/histories"
    {:name "histories#index"
     ;; Rails helper: project_histories
     :method :get}]
   ["/projects/:project_id/issues_step_runs"
    {:name "issues_step_runs#create"
     :method :post}]
   ["/projects/:project_id/issues_step_runs/:id"
    {:name "issues_step_runs#destroy"
     :method :delete}]
   ["/projects/:project_id/issues_step_runs/linked_issues"
    {:name "issues_step_runs#linked_issues"
     :method :get}]
   ["/p/:project_id/folders/:folder_id/move_entities_to_folder"
    {:name   "folders#move_entities_to_folder"
     :method :post}]
   ["/projects/:project_id/comments"
    {:name "comments#index"
     ;; Rails helper: project_comments
     :method :get}]
   ["/projects/:project_id/comments"
    {:name "comments#create"
     ;; Rails helper:
     :method :post}]
   ["/projects/:project_id/import/new"
    {:name "import#new"
     :method :get}]
   ["/projects/:project_id/comments/:id"
    {:name "comments#update"
     ;; Rails helper:
     :method :put}]
   ["/projects/:project_id/comments/:id"
    {:name "comments#destroy"
     ;; Rails helper:
     :method :delete}]
   ["/projects/:project_id/custom_fields/:id/add_list_value2"
    {:name "custom_fields#add_list_value2"
     ;; Rails helper: add_list_value2_project_custom_field
     :method :post}]
   ["/projects/:project_id/custom_fields"
    {:name "custom_fields#index"
     ;; Rails helper: project_custom_fields
     :method :get}]
   ["/projects/:project_id/custom_fields/new"
    {:name "custom_fields#new"
     ;; Rails helper: new_project_custom_field
     :method :get}]
   ["/projects/:project_id/sections"
    {:name "sections#index"
     :method :get}]
   ["/projects/:project_id/sections/settings_fields"
    {:name "sections#settings_fields"
     :method :get}]
   ["/projects/:project_id/sections/update_entity_fields"
    {:name "sections#update_entity_fields"
     :method :post}]
   ["/projects/:project_id/custom_views/left_pane_views"
    {:name "custom_views#left_pane_views"
     ;; Rails helper: left_pane_views_project_custom_views
     :method :get}]
   ["/projects/:p_id/custom_views/left_pane_views"
    {:name "custom_views#by_entity"
     :method :get}]
   ["/projects/:p_id/custom_views/[id]/fetch_filter"
    {:name "custom_views#fetch_filter"
     :method :get}]
   ["/projects/:p_id/custom_views/search"
    {:name "custom_views#search"
     :method :get}]
   ["/projects/:p_id/custom_views/find_matching"
    {:name "custom_views#find_matching"
     :method :post}]
   ;; XXX: we really should pick one name for project-id!
   ["/projects/:project_id/custom_views/new_editor_data"
    {:name "custom_views#new_editor_data"
     :method :get}]
   ["/projects/:project_id/custom_views/:id/editor_data"
    {:name "custom_views#editor_data"
     :method :get}]
   ["/projects/:project_id/custom_views/recompute_combined"
    {:name "custom_views#recompute_combined"
     :method :post}]
   ["/projects/:project_id/custom_views/create_view_editor"
    {:name "custom_views#create_view_editor"
     :method :post}]
   ["/projects/:project_id/custom_views/:id/update_view_editor"
    {:name "custom_views#update_view_editor"
     :method :patch}]
   ["/projects/:project_id/custom_views/:id/effective_ptql"
    {:name "custom_views#effective_ptql"
     :method :get}]
   ["/projects/:project_id/feedbacks"
    {:name "feedbacks#create"
     :method :post}]
   ["/projects/:project_id/feedbacks/for_feature"
    {:name "feedbacks#for_feature"
     :method :get}]
   ["/p/:p_id/folders"
    {:name "folders#by_entity"
     :method :get}]
   ["/p/:p_id/folders/[id]"
    {:name "folders#fetch_folder"
     :method :get}]
   ["/p/:p_id/folders/search"
    {:name "folders#search"
     :method :get}]
   ["/projects/:project_id/custom_views"
    {:name "custom_views#index"
     ;; Rails helper: project_custom_views
     :method :get}]
   ["/projects/:project_id/custom_views"
    {:name "custom_views#create"
     ;; Rails helper: project_custom_views
     :method :post}]
   ["/projects/:project_id/custom_views/create_from_fast_filters"
    {:name "custom_views#create_from_fast_filters"
     :method :post}]
   ["/projects/:project_id/pattachments/multiupload"
    {:name "pattachments#multiupload"
     ;; Rails helper: multiupload_project_pattachments
     :method :post}]
   ["/projects/:project_id/pattachments/staging_upload"
    {:name "pattachments#staging_upload"
     ;; Rails helper: staging_upload_project_pattachments
     :method :post}]
   ["/projects/:project_id/pattachments"
    {:name "pattachments#index"
     ;; Rails helper: project_pattachments
     :method :get}]
   ["/projects/:project_id/pattachments/:id"
    {:name "pattachments#destroy"
     ;; Rails helper:
     :method :delete}]
   ["/projects/:project_id/steps_params"
    {:name "steps_params#index"
     ;; Rails helper: project_steps_params
     :method :get}]
   ["/projects/:project_id/steps_params/:id"
    {:name "steps_params#update"
     :method :put}]
   ["/projects/:project_id/step_params"
    {:name "projects#step_params"
     :method :get}]
   ["/projects/:project_id/create_step_param"
    {:name "projects#create_step_param"
     :method :get}]
   ["/projects/:id/edit"
    {:name "projects#edit"
     ;; Rails helper: edit_project
     :method :get}]
   ["/p/:id/users_and_groups2"
    {:name "projects#users_and_groups2"
     ;; Rails helper: users_and_groups2_p
     :method :get}]
   ["/projects/:project_id/enhance_text"
    {:name "text_enhancements#enhance_text"
     :method :post}]
   ["/projects/:project_id/custom_enhance_text"
    {:name "text_enhancements#custom_enhance_text"
     :method :post}]
   ["/p/:p_id/summary"
    {:name "summary#index"
     ;; Rails helper: p_summary_index
     :method :get}]
   ["/p/:p_id/kanban/lanes"
    {:name "kanban#lanes"
     ;; Rails helper: lanes_p_kanban_index
     :method :get}]
   ["/p/:p_id/kanban"
    {:name "kanban#index"
     ;; Rails helper: p_kanban_index
     :method :get}]
   ["/p/:p_id/reports"
    {:name "reports#index"
     ;; Rails helper: p_reports
     :method :get}]
   ["/p/:p_id/issues/:id/attachments"
    {:name "issues#attachments"
     ;; Rails helper: attachments_p_issue
     :method :get}]
   ["/p/:p_id/issues/:id/comments"
    {:name "issues#comments"
     ;; Rails helper: comments_p_issue
     :method :get}]
   ["/p/:p_id/issues/:id/entity"
    {:name "issues#entity"
     ;; Rails helper:
     :method :get}]
   ["/p/:p_id/issues/:id/history"
    {:name "issues#history"
     ;; Rails helper: history_p_issue
     :method :get}]
   ["/p/:p_id/issues/:id/create_from_step"
    {:name "issues#create_from_step"
     :method :get}]
   ["/p/:p_id/issues/:id/create_from_et_annotation"
    {:name "issues#create_from_et_annotation"
     :method :get}]
   ["/p/:p_id/issues"
    {:name "issues#index"
     ;; Rails helper: p_issues
     :method :get}]
   ["/p/:p_id/issues/:id"
    {:name "issues#show"
     :method :get}]
   ["/p/:p_id/issues/list2"
    {:name "issues#list2"
     ;; Rails helper: list2_p_issues
     :method :get}]
   ["/p/:p_id/issues"
    {:name "issues#create"
     :method :post}]
   ["/p/:p_id/issues/:id/update2"
    {:name "issues#update2"
     :method :put}]
   ["/p/:p_id/issues/print"
    {:name "issues#print"
     :method :get}]
   ["/p/:p_id/issues/:id"
    {:name "issues#destroy"
     :method :delete}]
   ["/p/:p_id/issues/:id/delete_traceability"
    {:name "issues#delete_traceability"
     :method :post}]
   ["/p/:p_id/instances/:id/edit"
    {:name "instances#edit"
     :method :get}]
   ["/p/:p_id/issues/:id/edit"
    {:name "issues#edit"
     :method :get}]
   ["/p/:p_id/issues/batch_edit"
    {:name "issues#batch_edit"
     :method :get}]
   ["/p/:p_id/issues/batch_find_and_replace"
    {:name "issues#find_and_replace"
     :method :get}]
   ["/p/:p_id/issues/batch_delete"
    {:name "issues#batch_delete"
     :method :get}]
   ["/p/:p_id/issues/new"
    {:name "issues#new"
     ;; Rails helper: new_p_test
     :method :get}]
   ["/p/:p_id/issues/jump_to"
    {:name "issues#jump_to"
     :method :post}]

   ["/p/:p_id/tests/list2"
    {:name "qtest_designs#list2"
     ;; Rails helper: list2_p_tests
     :method :get}]
   ["/p/:p_id/tests"
    {:name "qtest_designs#index"
     ;; Rails helper: p_tests
     :method :get}]
   ["/p/:p_id/tests/:id/entity"
    {:name "qtest_designs#entity"
     :method :get}]
   ["/p/:p_id/tests/:id/steps"
    {:name "qtest_designs#steps"
     :method :get}]
   ["/p/:p_id/tests/new"
    {:name "qtest_designs#new"
     ;; Rails helper: new_p_test
     :method :get}]
   ["/p/:p_id/tests"
    {:name "qtest_designs#create"
     :method :post}]
   ["/p/:p_id/tests/:id"
    {:name "qtest_designs#update"
     :method :put}]
   ["/p/:p_id/tests/:id/history"
    {:name "qtest_designs#history"
     :method :get}]
   ["/p/:p_id/tests/:id/attachments"
    {:name "qtest_designs#attachments"
     :method :get}]
   ["/p/:p_id/tests/:id/comments"
    {:name "qtest_designs#comments"
     :method :get}]
   ["/p/:p_id/tests/:id/edit"
    {:name "qtest_designs#edit"
     :method :get}]
   ["/p/:p_id/tests/:id/convert_test_type"
    {:name "qtest_designs#convert_test_type"
     :method :put}]
   ["/p/:p_id/tests/:id/clone_entity"
    {:name "qtest_designs#clone_entity"
     :method :post}]
   ["/p/:p_id/tests/:id"
    {:name "qtest_designs#destroy"
     :method :delete}]
   ["/p/:p_id/tests/:id/link_entities"
    {:name "qtest_designs#link_entities"
     :method :post}]
   ["/p/:p_id/tests/:id/unlink_entity"
    {:name "qtest_designs#unlink_entity"
     :method :post}]
   ["/p/:p_id/tests/:id/create_test_from_requirement"
    {:name "qtest_designs#create_test_from_requirement"
     :method :get}]
   ["/p/:p_id/tests/new_from_et"
    {:name "qtest_designs#new_from_et"
     :method :get}]
   ["/p/:p_id/tests/print"
    {:name "qtest_designs#print"
     :method :get}]
   ["/p/:p_id/tests/:id/remove_label"
    {:name "qtest_designs#remove_label"
     :method :post}]
   ["/p/:p_id/tests/jump_to"
    {:name "tests#jump_to"
     :method :post}]
   ["/p/:p_id/tests/batch_edit"
    {:name "tests#batch_edit"
     :method :get}]
   ["/p/:p_id/tests/batch_find_and_replace"
    {:name "tests#find_and_replace"
     :method :get}]
   ["/p/:p_id/tests/batch_delete"
    {:name "tests#batch_delete"
     :method :get}]
   ["/p/:p_id/tests/batch_clone"
    {:name "tests#batch_clone"
     ;; Rails helper: new_project_permutation
     :method :get}]
   ["/p/:p_id/tests/smart_fox_apply2"
    {:name "qtest_designs#smart_fox_apply2"
     :method :post}]
   ["/p/:p_id/tests/:id/update_from_parent_data"
    {:name "qtest_designs#update_from_parent_data"
     :method :post}]
   ["/p/:p_id/sets/new"
    {:name "common#create_testset"
     ;; Rails helper:
     :method :get}]
   ["/p/:p_id/sets/:id/edit"
    {:name "suites#edit"
     :method :get}]
   ["/p/:p_id/sets/:s_id/et/:id/edit"
    {:name "et#edit"
     :method :get}]
   ["/p/:p_id/requirements/:id/edit"
    {:name "requirements#edit"
     :method :get}]
   ["/p/:p_id/requirements/:id"
    {:name "requirements#destroy"
     :method :delete}]
   ["/p/:p_id/requirements/:id/link_entities"
    {:name "requirements#link_entities"
     :method :post}]
   ["/p/:p_id/requirements/:id/unlink_entity"
    {:name "requirements#unlink_entity"
     :method :post}]
   ["/p/:p_id/requirements/:id/change_testing_scope"
    {:name "requirements#change_testing_scope"
     :method :post}]
   ["/p/:p_id/instances/fast_run"
    {:name "instances#fast_run"
     ;; Rails helper: fast_run_p_instances
     :method :get}]
   ["/p/:p_id/instances/batch_available_version_labels"
    {:name "instances#batch_available_version_labels"
     :method :get}]
   ["/p/:p_id/instances/batch_change_test_version"
    {:name "instances#batch_change_test_version"
     :method :post}]
   ["/p/:p_id/instances/update_cell"
    {:name "instances#update_cell"
     ;; Rails helper: update_cell_p_instances
     :method :post}]
   ["/p/:p_id/instances/batch_delete"
    {:name "instances#batch_delete"
     ;; Rails helper: batch_delete_p_instances
     :method :get}]
   ["/p/:p_id/instances/batch_edit"
    {:name "instances#batch_edit"
     ;; Rails helper: batch_edit_p_instances
     :method :get}]
   ["/p/:p_id/instances/batch_delete_apply"
    {:name "instances#batch_delete_apply"
     ;; Rails helper: batch_delete_apply_p_instances
     :method :post}]
   ["/p/:p_id/instances/:id"
    {:name "instances#destroy"
     ;; Rails helper:
     :method :delete}]
                                        ; TODO: add_tests_multiple_suites should be POST not GET
                                        ; reusing existing backend endpoint, so leaving at the moment.
                                        ; need to change it after we stop use the old ui
   ["/p/:p_id/sets/add_tests_multiple_suites"
    {:name "suites#link_tests_to_testsets"
     :method :get}]
   ["/p/:p_id/form_entities/available_fields"
    {:name "form_entities#available_fields"
     ;; Rails helper: available_fields_p_form_entities
     :method :get}]
   ["/p/:p_id/form_entities/sections"
    {:name "form_entities#sections"
     :method :get}]
   ["/p/:p_id/sets/:id/clone_entity"
    {:name "suites#clone_entity"
     ;; Rails helper: clone_entity_p_set
     :method :post}]
   ["/p/:p_id/sets/:id/clone_entity_with_failed_tests"
    {:name "suites#clone_entity_with_failed_tests"
     ;; Rails helper: clone_entity_with_failed_tests_p_set
     :method :post}]
   ["/p/:p_id/sets/:id/add_tests"
    {:name "suites#add_tests"
     ;; Rails helper: add_tests_p_set
     :method :post}]
   ["/p/:p_id/sets/:id/sort_instances"
    {:name "suites#sort_instances"
     ;; Rails helper: sort_instances_p_set
     :method :get}]
   ["/p/:p_id/sets/:id/traceability_instances"
    {:name "suites#traceability_instances"
     ;; Rails helper: traceability_instances_p_set
     :method :get}]
   ["/p/:p_id/sets/:id/run_now"
    {:name "suites#run_now"
     ;; Rails helper: run_now_p_set
     :method :post}]
   ["/p/:p_id/sets/:id/delete_recurrence"
    {:name "suites#delete_recurrence"
     ;; Rails helper: delete_recurrence_p_set
     :method :post}]
   ["/p/:p_id/sets/:id/set_recurrence"
    {:name "suites#set_recurrence"
     ;; Rails helper: set_recurrence_p_set
     :method :post}]
   ["/p/:p_id/sets/:id/graphs"
    {:name "suites#graphs"
     ;; Rails helper: graphs_p_set
     :method :get}]
   ["/p/:p_id/sets/:id/history"
    {:name "suites#history"
     ;; Rails helper: history_p_set
     :method :get}]
   ["/p/:p_id/sets/:id/attachments"
    {:name "suites#attachments"
     ;; Rails helper: attachments_p_set
     :method :get}]
   ["/p/:p_id/sets/:id/comments"
    {:name "suites#comments"
     ;; Rails helper: comments_p_set
     :method :get}]
   ["/p/:p_id/sets/:id/entity"
    {:name "suites#entity"
     ;; Rails helper: entity_p_set
     :method :get}]
   ["/p/:p_id/sets/:id/linked_issues"
    {:name "suites#linked_issues"
     ;; Rails helper: linked_issues_p_set
     :method :get}]
   ["/p/:p_id/instances/:id/entity"
    {:name "instances#entity"
     :method :get}]
   ["/p/:p_id/sets/:set_id/instances/:id/edit"
    {:name "instances#edit2"
     :method :get}]
   ["/p/:p_id/instances/:id/attachments"
    {:name "instances#attachments"
     :method :get}]
   ["/p/:p_id/sets/:set_id/instances/sort"
    {:name "instances#sort"
     ;; Rails helper: sort_p_set_instances
     :method :post}]
   ["/p/:p_id/sets/:set_id/instances/list_instances"
    {:name "instances#list_instances"
     ;; Rails helper: list_instances_p_set_instances
     :method :get}]
   ["/p/:p_id/sets/:set_id/instances/:id/run_now"
    {:name "instances#run_now"
     ;; Rails helper: run_now_p_set_instance
     :method :post}]
   ["/p/:p_id/sets/:set_id/instances/:id"
    {:name "instances#update"
     :method :put}]
   ["/p/:p_id/sets/:set_id/instances"
    {:name "instances#index"
     ;; Rails helper: p_set_instances
     :method :get}]
   ["/p/:p_id/instances/:id/history"
    {:name "instances#history"
     :method :get}]
   ["/p/:p_id/qtest_runs/:id/entity"
    {:name "qtest_runs#entity"
     :method :get}]
   ["/p/:p_id/qtest_runs/:id/navigation"
    {:name "qtest_runs#navigation"
     :method :get}]
   ["/p/:p_id/qtest_runs/:id/steps"
    {:name "qtest_runs#steps"
     :method :get}]
   ["/p/:p_id/qtest_runs/:id/get_duration"
    {:name "qtest_runs#get_duration"
     :method :get}]
   ["/p/:p_id/qtest_runs/:id/update_duration"
    {:name "qtest_runs#update_duration"
     :method :post}]
   ["/p/:p_id/qtest_runs/:id"
    {:name "qtest_runs#update"
     :method :put}]
   ["/p/:p_id/qtest_runs/:id/history"
    {:name "qtest_runs#history"
     :method :get}]
   ["/p/:p_id/qtest_runs/:id"
    {:name "qtest_runs#destroy"
     :method :delete}]
   ["/p/:p_id/qtest_runs/:id/edit"
    {:name "qtest_runs#edit"
     :method :get}]
   ["/p/:p_id/qtest_runs/:id/retest_run"
    {:name "qtest_runs#retest_run"
     :method :get}]
   ["/p/:p_id/qtest_runs/:id/update_parent_test_steps"
    {:name "qtest_runs#update_parent_test_steps"
     :method :post}]
   ["/projects/:project_id/step_runs/:id/pass_all_steps"
    {:name "step_runs#pass_all_steps"
     :method :post}]
   ["/projects/:project_id/step_runs/:id/update_status"
    {:name "step_runs#update_status"
     :method :post}]
   ["/projects/:project_id/step_runs/:id/update_actual_results"
    {:name "step_runs#update_actual_results"
     :method :post}]
   ["/projects/:project_id/step_runs/:id/bug_defaults"
    {:name "step_runs#bug_defaults"
     :method :get}]
   ["/p/:p_id/qtest_runs/:id/rewind_runs_dates"
    {:name "qtest_runs#rewind_runs_dates"
     :method :post}]
   ["/projects/:project_id/step_runs/:id"
    {:name "step_runs#update"
     :method :put}]
   ["/projects/:project_id/step_runs/:id/create_new"
    {:name "step_runs#create_new"
     :method :post}]
   ["/projects/:project_id/step_runs/:id"
    {:name "step_runs#destroy"
     :method :delete}]
   ["/p/:p_id/sets/jump_to"
    {:name "suites#jump_to"
     :method :post}]
   ["/p/:p_id/sets/:id/toggle_enforce_run_order"
    {:name "suite#toggle_enforce_run_order"
     :method :post}] 
   ["/p/:p_id/sets/print"
    {:name "suites#print"
     ;; Rails helper: print_p_sets
     :method :get}]
   ["/p/:p_id/sets"
    {:name "suites#index"
     ;; Rails helper: p_sets
     :method :get}]
   ["/p/:p_id/sets/list2"
    {:name "suites#list2"
     ;; Rails helper: list2_p_sets
     :method :get}]
   ["/p/:p_id/sets"
    {:name "suites#create"
     ;; Rails helper:
     :method :post}]
   ["/p/:p_id/sets/:id"
    {:name "suites#show"
     ;; Rails helper: p_set
     :method :get}]
   ["/p/:p_id/sets/:id"
    {:name "suites#update"
     ;; Rails helper:
     :method :put}]
   ["/p/:p_id/sets/:id"
    {:name "suites#destroy"
     ;; Rails helper:
     :method :delete}]
   ["/p/:p_id/sets/batch_edit"
    {:name "suites#batch_edit"
     :method :get}]
   ["/projects/:project_id/permutations/new"
    {:name "suites#create_permutations"
     ;; Rails helper: new_project_permutation
     :method :get}]
   ["/p/:p_id/sets/batch_clone"
    {:name "suites#batch_clone"
     ;; Rails helper: new_project_permutation
     :method :get}]
   ["/p/:p_id/sets/batch_find_and_replace"
    {:name "suites#find_and_replace"
     :method :get}]
   ["/p/:p_id/sets/batch_delete"
    {:name "suites#batch_delete"
     :method :get}]
   ["/p/:p_id/sets/deleted"
    {:name "suites#restore"
     :method :get}]

   ["/p/:p_id/requirements"
    {:name "requirements#create"
     :method :post}]
   ["/p/:p_id/requirements/:id"
    {:name "requirements#update"
     :method :put}]
   ["/p/:p_id/requirements/:id/history"
    {:name "requirements#history"
     :method :get}]
   ["/p/:p_id/requirements/:id/attachments"
    {:name "requirements#attachments"
     :method :get}]
   ["/p/:p_id/requirements/:id/comments"
    {:name "requirements#comments"
     :method :get}]
   ["/p/:p_id/requirements/:id/entity"
    {:name "requirements#entity"
     :method :get}]
   ["/p/:p_id/requirements"
    {:name "requirements#index"
     ;; Rails helper: p_requirements
     :method :get}]
   ["/p/:p_id/requirements/list2"
    {:name "requirements#list2"
     ;; Rails helper: list2_p_requirements
     :method :get}]
   ["/p/:p_id/requirements/new"
    {:name "requirements#new"
     :method :get}]
   ["/p/:p_id/requirements/jump_to"
    {:name "requirements#jump_to"
     :method :post}]
   ["/p/:p_id/requirements/print"
    {:name "requirements#print"
     :method :post}]
   ["/p/:p_id/requirements/batch_edit"
    {:name "requirements#batch_edit"
     :method :get}]
   ["/p/:p_id/requirements/batch_delete"
    {:name "requirements#batch_delete"
     :method :get}]
   ["/p/:p_id/requirements/batch_find_and_replace"
    {:name "requirements#find_and_replace"
     :method :get}]
   ["/p/:p_id/requirements/fetch_tree"
    {:name "requirements#fetch_parent_tree"
     :method :get}]
   ["/p/:p_id/requirements/[id]/fetch_item"
    {:name "requirements#fetch_parent_node"
     :method :get}]
   ["/p/:p_id/requirements/search"
    {:name "requirements#search_parent"
     :method :get}]

   ["/p/:p_id/system_fields/:id/add_list_value2"
    {:name "system_fields#add_list_value2"
     ;; Rails helper: add_list_value2_p_system_field
     :method :post}]
   ["/p/:p_id/system_fields"
    {:name "system_fields#index"
     ;; Rails helper: p_system_fields
     :method :get}]
   ["/integrations/p/:p_id/jira_modal/jira_update_modal_body"
    {:name "jira_modal#jira_update_modal_body"
     :method :get}]
   ["/integrations/p/:p_id/jira_modal/jira_fields_to_update"
    {:name "jira_modal#jira_fields_to_update"
     :method :post}]
   ["/integrations/p/:p_id/jira_modal/create"
    {:name "jira_modal#create"
     :method :post}]
   ["/projects/:project_id/integration_setting_jira_two_ways/jira_projects"
    {:name "integration_settings#jira_projects"
     :method :get}]
   ["/projects/:project_id/integration_setting_jira_two_ways/:id/entity_mapping"
    {:name "integration_settings#entity_mapping"
     :method :get}]
   ["/projects/:project_id/integration_setting_jira_two_ways/:id/available_jira_projects"
    {:name "integration_settings#available_jira_projects"
     :method :get}]
   ["/projects/:project_id/integration_setting_jira_two_ways/:id/entity_mapping_issue_types"
    {:name "integration_settings#entity_mapping_issue_types"
     :method :get}]
   ["/projects/:project_id/integration_setting_jira_two_ways/:id/update_entity_mapping"
    {:name "integration_settings#update_entity_mapping"
     :method :post}]
   ["/projects/:project_id/integration_setting_jira_two_ways/:id/trigger_milestones_sync"
    {:name "integration_settings#trigger_milestones_sync"
     :method :post}]
   ["/projects/:project_id/integration_setting_two_ways/:id/entity_mapping"
    {:name "two_way_integration_settings#entity_mapping"
     :method :get}]
   ["/projects/:project_id/integration_setting_two_ways/:id/available_azure_projects"
    {:name "azure_integration_settings#available_azure_projects"
     :method :get}]
   ["/projects/:project_id/integration_setting_two_ways/:id/entity_mapping_work_item_types"
    {:name "two_way_integration_settings#entity_mapping_work_item_types"
     :method :get}]
   ["/projects/:project_id/integration_setting_two_ways/:id/update_entity_mapping"
    {:name "two_way_integration_settings#update_entity_mapping"
     :method :put}]
   ["/projects/:project_id/integration_setting_two_ways/:id/entity_mapping_space_task_types"
    {:name "clickup_integration_settings#entity_mapping_space_task_types"
     :method :get}]
   ["/projects/:project_id/integration_setting_two_ways/:id/available_clickup_spaces"
    {:name "clickup_integration_settings#available_clickup_spaces"
     :method :get}]
   ["/projects/:project_id/integration_setting_two_ways/:id/available_clickup_lists"
    {:name "clickup_integration_settings#available_clickup_lists"
     :method :get}]
   ["/projects/:project_id/integration_setting_two_ways/bugtracker_projects"
    {:name "bugtracker_settings#bugtracker_projects"
     :method :get}]
   ["/projects/:project_id/integration_setting_two_ways/check_user_linked"
    {:name "bugtracker_settings#check_user_linked"
     :method :get}]
   ["/projects/:project_id/integration_setting_two_ways/:id/update_sync_jira_filters_from_import_modal"
    {:name "integration_setting_jira_two_ways#update_sync_jira_filters_from_import_modal"
     :method :post}]
   ["/projects/:project_id/integration_setting_two_ways/:id/get_jira_all_filters"
    {:name "integration_setting_jira_two_ways#get_jira_all_filters"
     :method :get}]
   ["/projects/:project_id/integration_setting_jira_two_ways/:integrated_bugtracker_id/query_jira_users?term=%s&startAt=%d&maxResults=%d&issue_type_id=%d"
    {:name "integration_setting_jira_two_ways#get_user_id_by_name"
     :method :get}]
   ["/projects/:project_id/integration_setting_jira_two_ways/:integrated_bugtracker_id/refresh_field_values"
    {:name "integration_setting_jira_two_ways#refresh_field_values"
     :method :post}]
   ["/p/:p_id/issues/import_from_jira"
    {:name "issues#import_from_jira"
     :method :post}]
   ["/p/:p_id/requirement_integrations/import_from_jira"
    {:name "requirement_integrations#import_from_jira"
     :method :post}]
   ["/p/:p_id/issues/import_from_youtrack"
    {:name "issues#import_from_youtrack"
     :method :post}]
   ["/p/:p_id/requirement_integrations/import_from_youtrack"
    {:name "requirement_integrations#import_from_youtrack"
     :method :post}]
   ["/p/:p_id/issues/import_from_click_up"
    {:name "issues#import_from_click_up"
     :method :post}]
   ["/p/:p_id/requirement_integrations/import_from_click_up"
    {:name "requirement_integrations#import_from_click_up"
     :method :post}]
   ["/p/:p_id/issues/import_from_azure_devops"
    {:name "issues#import_from_azure_devops"
     :method :post}]
   ["/p/:p_id/requirement_integrations/import_from_azure_devops"
    {:name "requirement_integrations#import_from_azure_devops"
     :method :post}]
   ["/p/:p_id/issues/import_from_pivotal"
    {:name "issues#import_from_pivotal"
     :method :post}]
   ["/p/:p_id/requirement_integrations/import_from_pivotal"
    {:name "requirement_integrations#import_from_pivotal"
     :method :post}]
   ["/p/:p_id/requirement_integrations/:id/unlink_from_external"
    {:name "requirement_integrations#unlink_from_external"
     :method :post}]
   ["/p/:p_id/requirement_integrations/:id/link_to_jira"
    {:name "requirement_integrations#link_to_jira"
     :method :post}]
   ["/p/:p_id/requirement_integrations/:id/link_to_clickup"
    {:name "requirement_integrations#link_to_clickup"
     :method :post}]
   ["/p/:p_id/issues/get_bugtracker_project_list"
    {:name "issues#get_bugtracker_project_list"
     :method :get}]
   ["/p/:p_id/requirement_integrations/get_bugtracker_project_list"
    {:name "requirement_integrations#get_bugtracker_project_list"
     :method :get}]
   ["/integrations/p/:p_id/bugtracker_modal/fail_n_issue_create"
    {:name "bugtracker_modal#fail_n_issue_create"
     :method :post}]
   ["/integrations/p/:p_id/bugtracker_modal/bugtracker_update_modal_body"
    {:name "bugtracker_modal#bugtracker_update_modal_body"
     :method :get}]
   ["/integrations/p/:p_id/bugtracker_modal/bugtracker_fields_to_update"
    {:name "bugtracker_modal#bugtracker_fields_to_update"
     :method :post}]
   ["/p/:p_id/folders"
    {:name "folders#index"
     ;; Rails helper: p_folders
     :method :get}]
   ["/p/:p_id/xbot/"
    {:name "suites#automation"
     ;; Rails helper: p_xbot_index
     :method :get}]
   ["/p/:p_id/xbot/kill_running_item"
    {:name "xbot#kill_running_item"
     ;; Rails helper: kill_running_item_p_xbot_index
     :method :post}]
   ["/p/:p_id/xbot/update_agent_client_id"
    {:name "xbot#update_agent_client_id"
     ;; Rails helper: update_agent_client_id_p_xbot_index
     :method :post}]
   ["/p/:p_id/xbot/toggle_enable_agent"
    {:name "xbot#toggle_enable_agent"
     ;; Rails helper: toggle_enable_agent_p_xbot_index
     :method :post}]
   ["/p/:p_id/xbot/remove_agent"
    {:name "xbot#remove_agent"
     ;; Rails helper: remove_agent_p_xbot_index
     :method :post}]
   ["/p/:p_id/xbot/list_queue"
    {:name "xbot#list_queue"
     ;; Rails helper: list_queue_p_xbot_index
     :method :get}]
   ["/p/:p_id/xbot/list_schedule"
    {:name "xbot#list_schedule"
     ;; Rails helper: list_schedule_p_xbot_index
     :method :get}]
   ["/p/:p_id/xbot/list_running"
    {:name "xbot#list_running"
     ;; Rails helper: list_running_p_xbot_index
     :method :get}]
   ["/p/:p_id/xbot/list_history"
    {:name "xbot#list_history"
     ;; Rails helper: list_history_p_xbot_index
     :method :get}]
   ["/p/:p_id/milestones/list"
    {:name "milestones#list"
     ;; Rails helper: list_p_milestones
     :method :get}]
   ["/p/:p_id/milestones/list2"
    {:name "milestones#list2"
     ;; Rails helper: list2_p_tests
     :method :get}]
   ["/p/:p_id/issues/:id/link_entities"
    {:name "issues#link_entities"
     :method :post}]
   ["/p/:p_id/milestones/:id/link_entities"
    {:name "milestones#link_entities"
     ;; Rails helper: link_entities_p_milestone
     :method :post}]
   ["/p/:p_id/milestones/:id/unlink_entities"
    {:name "milestones#unlink_entities"
     ;; Rails helper: unlink_entities_p_milestone
     :method :post}]
   ["/p/:p_id/issues/:id/linked_entities"
    {:name "issues#linked_entities"
     :method :get}]
   ["/p/:p_id/milestones/:id/linked_entities"
    {:name "milestones#linked_entities"
     ;; Rails helper: linked_entities_p_milestone
     :method :get}]
   ["/p/:p_id/milestones/:id/charts_data"
    {:name "milestones#charts_data"
     :method :get}]
   ["/p/:p_id/milestones/:id/history"
    {:name "milestones#history"
     ;; Rails helper: history_p_milestone
     :method :get}]
   ["/p/:p_id/milestones/:id/attachments"
    {:name "milestones#attachments"
     ;; Rails helper: attachments_p_milestone
     :method :get}]
   ["/p/:p_id/milestones/:id/comments"
    {:name "milestones#comments"
     ;; Rails helper: comments_p_milestone
     :method :get}]
   ["/p/:p_id/milestones/:id/entity"
    {:name "milestones#entity"
     ;; Rails helper: entity_p_milestone
     :method :get}]
   ["/p/:p_id/milestones"
    {:name "milestones#create"
     ;; Rails helper:
     :method :post}]
   ["/p/:p_id/milestones"
    {:name "milestones#index"
     :method :get}]
   ["/p/:p_id/milestones/new"
    {:name "milestones#new"
     :method :get}]
   ["/p/:p_id/milestones/:id"
    {:name "milestones#show"
     ;; Rails helper: p_milestone
     :method :get}]
   ["/p/:p_id/milestones/:id/edit"
    {:name "milestones#edit"
     ;; Rails helper: p_milestone
     :method :get}]
   ["/p/:p_id/milestones/:id"
    {:name "milestones#update"
     ;; Rails helper:
     :method :put}]
   ["/p/:project-id/milestones/:id"
    {:name ::m.events/delete
     :method :delete}]
   ["/p/:project-id/milestones/:milestone-id/readiness_index"
    {:name   ::ri.events/fetch
     :method :get}]
   ["/p/:project-id/milestones/:milestone-id/archive"
    {:name   ::m.events/archive
     :method :post}]
   ["/p/:project-id/milestones/:milestone-id/unarchive"
    {:name   ::m.events/unarchive
     :method :post}]
   ["/personals"
    {:name "personals#index"
     ;; Rails helper: personals
     :method :get}]
   ["/users/:id/edit"
    {:name "users#edit"
     ;; Rails helper: edit_user
     :method :get}]
   ["/tags/cloud"
    {:name "tags#cloud"
     ;; Rails helper: cloud_tags
     :method :get}]
   ["/watchers/:id"
    {:name "watchers#delete"
     :method :delete}]
   ["/watchers"
    {:name "watchers#create"
     :method :post}]
   ["/p/:p_id/version_labels"
    {:name "version_labels#index"
     :method :get}]
   ["/p/:p_id/version_labels"
    {:name "version_labels#create"
     :method :post}]
   ["/p/:p_id/version_labels/test_labels"
    {:name "version_labels#test_labels"
     :method :get}]
   ["/p/:p_id/version_labels/apply_to_test"
    {:name "version_labels#apply_to_test"
     :method :post}]
   ["/p/:p_id/version_labels/available_labels"
    {:name "version_labels#available_labels"
     :method :get}]
   ["/p/:p_id/version_labels/batch_version_label_apply"
    {:name "version_labels#batch_version_label_apply"
     :method :post}]
   ;; service tokens
   ["/p/:p_id/service_token"
    {:name "service_tokens#create"
     :method :post}]
   ;; assistant
   ["/p/:p_id/assistant/usage"
    {:name "assistant#usage"
     :method :post}]
   ["/p/:p_id/assistant/budget"
    {:name "assistant#budget"
     :method :get}]
   ;; assistant conversations
   ["/p/:p_id/assistant/conversations"
    {:name "assistant_conversations#index"
     :method :get}]
   ["/p/:p_id/assistant/conversations"
    {:name "assistant_conversations#create"
     :method :post}]
   ["/p/:p_id/assistant/conversations/:id"
    {:name "assistant_conversations#show"
     :method :get}]
   ["/p/:p_id/assistant/conversations/:id"
    {:name "assistant_conversations#update"
     :method :patch}]
   ["/p/:p_id/assistant/conversations/:id"
    {:name "assistant_conversations#destroy"
     :method :delete}]
   ["/p/:p_id/assistant/conversations/:id/restore"
    {:name "assistant_conversations#restore"
     :method :post}]
   ;; assistant messages
   ["/p/:p_id/assistant/conversations/:assistant_conversation_id/messages"
    {:name "assistant_messages#create"
     :method :post}]
   ["/p/:p_id/assistant/conversations/:assistant_conversation_id/messages/:id"
    {:name "assistant_messages#update"
     :method :patch}]])

(def router (r/router backend-routes
                      {:conflicts nil}))
                       ;:router r/linear-router


(defn get-route
  [name path-params]
  (let [match (rf/match-by-name router name path-params)]
    (if (r/partial-match? match)
      (js/console.warn "partial match for get-route" name path-params)
      match)))

(defn get-url
  ([name]
   (get-url name nil))
  ([name path-params]
   (get-url name path-params nil))
  ([name path-params query-params] 
   (let [match (rf/match-by-name router name path-params)]
     (if (nil? match)
       (js/console.warn "no route for get-uri" name path-params)
       (if (r/partial-match? match)
         (js/console.warn "partial match for get-uri" name path-params)
         (let [retval (r/match->path match query-params)]
           ;(js/console.log "get-uri result" name path-params "result" retval)
           retval))))))

(defn get-url2
  "use route :params to map params names
   {:p_id :project/id
    :id   :milestone/id}"
  ([name entity]
   (get-url2 name entity nil))
  ([name entity query-params]
   (let [params (some-> entity utils/->kebab-case-keys)
         match  (rf/match-by-name router name params)]
     (if (or (nil? match) (r/partial-match? match))
       (js/console.warn "no route for get-url2" name entity)
       [(-> match :data :method) (r/match->path match query-params)]))))

(defn- maybe-rematch-with-project-id
  [match path-params]
  ;; It's either :p_id or :project_id
  (if (r/partial-match? match)
    (let [required (:required match)
          name (get-in match [:data :name])
          path-params (if (and (contains? required :p_id)
                               (not (contains? path-params :p_id)))
                        (assoc path-params :p_id (:id @(re-frame/subscribe [::subs/current-project])))
                        path-params)
          path-params (if (and (contains? required :project_id)
                               (not (contains? path-params :project_id)))
                        (assoc path-params :project_id (:id @(re-frame/subscribe [::subs/current-project])))
                        path-params)]
      ;; Re-match with enriched path-params
      (rf/match-by-name router name path-params))
    ;; Just return existing match
    match))

;; Use only in reagent render !
(defn get-url-view
  ([name]
   (get-url-view name nil nil))
  ([name path-params]
   (get-url-view name path-params nil))
  ([name path-params query-params]
   (when-not (reagent/current-component)
     (js/console.warn "get-uri-view was used outside of reagent render function !"))

   (let [match (rf/match-by-name router name path-params)
         ;; Project id is required, but not provided - use default one
         match (maybe-rematch-with-project-id match path-params)]
     (when (nil? match)
       (js/console.warn "Invalid route called" name))

     (if-not (r/partial-match? match)
       (r/match->path match query-params)
       (js/console.warn "Invalid link" name path-params)))))

(def help-menu-help-center-url "https://www.practitest.com/help/")
(def help-menu-help-ctt-url "https://www.practitest.com/help/test-planning-and-execution/tests/scripted-manual-tests/#call-a-test")
(def help-menu-discussions-forum-url "https://discuss.practitest.com/")
(def help-menu-feature-request-url "https://practitest.uservoice.com/")
(def help-menu-get-certified-url "https://participant.easy-lms.com/practitest-academy/login")
(def jira-cloud-sprint-sync-url "https://www.practitest.com/help/integrations/jira-cloud/#sprint-sync")
(def jira-server-sprint-sync-url "https://www.practitest.com/help/integrations/jira-server-and-data-center/#sprint-sync")

